import React from 'react';
import ReactDOM from 'react-dom';
import Helmet from 'react-helmet';
import { Theme } from '@mui/material/styles';
import './index.modules.scss';
import App from './App';
// it could be your App.tsx file or theme file that is included in your tsconfig.json


import appConfig from './config/app.config';

import reportWebVitals from './reportWebVitals';

import { UserContextProvider } from './store/user-context';
import { GamesContextProvider } from './store/games-context';
import { RunsContextProvider } from './store/runs-context';
import { ColorModeContextProvider } from './store/color-context';

declare module '@mui/styles/defaultTheme' {
  interface DefaultTheme extends Theme {}
}


ReactDOM.render(
  <React.StrictMode>
    <Helmet>
      <title>{appConfig.streamerDisplayText} {appConfig.run} Timeline and Stats</title>
      <meta name="description" content={`${appConfig.streamerDisplayText} ${appConfig.run}Record`} />
    </Helmet>
    <UserContextProvider>
      <GamesContextProvider>
        <RunsContextProvider>
          <ColorModeContextProvider>
            <App />
          </ColorModeContextProvider>
        </RunsContextProvider>
      </GamesContextProvider>
    </UserContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
